import { useCampaign } from 'shared/campaign'

import { useUrlChanges } from '../micro-frontend'
import { type SwhConfigStore } from '../swh-config-context'

export const useCatalogCampaign = (config: SwhConfigStore) => {
  const currentUrl = useUrlChanges()
  const campaign = useCampaign(config.user?.id ?? '', { flag: 'campaign-catalog', screen: 'catalog' })
  const hasStore = !!config.store?.id

  if (!hasStore || currentUrl !== '/produtos') {
    return null
  }

  return campaign
}
